import {
  DETAIL_GET_COMMENT_LIST_REQUEST,
  DETAIL_GET_GRADE_REQUEST,
  DETAIL_ADD_COMMENT_REQUEST,
  DETAIL_ADD_ZAN_REQUEST,
  USER_SCORE_FORSTORE_REQUEST,
} from '../constants/comment';

export const getCommentList = param => ({
  type: DETAIL_GET_COMMENT_LIST_REQUEST,
  ...param,
});

export const getGrade = param => ({
  type: DETAIL_GET_GRADE_REQUEST,
  ...param,
});

export const addComment = param => ({
  type: DETAIL_ADD_COMMENT_REQUEST,
  ...param,
});

export const addZan = param => ({
  type: DETAIL_ADD_ZAN_REQUEST,
  ...param,
});

/**
 * 用户给商店打分，只会打一次
 * @param {*} param
 */
export const addScoreForStore = param => ({
  type: USER_SCORE_FORSTORE_REQUEST,
  ...param,
});
